import React, { useEffect, useRef } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import withStore from "../../Components/Unstated/withStore";
import "./Map.sass";
import MapStore from "./Store/MapStore";
import { defaultMapConfig } from "./Data/config";
import Markers from "./Components/Markers";
import mapboxgl, { Map as MapBoxMap } from "mapbox-gl";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const Map = ({
  markers,
  children,
  mapStore: {
    state: { loaded },
    init
  }
}) => {
  const map = useRef(null);

  useEffect(() => {
    if (map) {
      const mapBoxMap = new MapBoxMap(defaultMapConfig(map.current));
      init(mapBoxMap);
    }
  }, [init]);

  return (
    <div className="mapWrapper">
      <div className="map" ref={map}>
        {loaded && <Markers markers={markers} />}
      </div>
      {children}
    </div>
  );
};
export default withStore([MapStore])(Map);
